<template>
  <div class="component-model">
    <a-cascader
      :fieldNames="{ label: 'label', value: 'value', children: 'children' }"
      :options="areaOptions"
      :changeOnSelect="changeOnSelect"
      @change="areaChange"
      v-model="areaData"
      placeholder="请选择地区" :style="{'max-width':maxWidth}"></a-cascader>
    <span v-if="showText">{{ showText }}</span>
  </div>
</template>
<script>
export default {
  name: 'AreaKinkage',
  components: {},
  props: {
    maxWidth: {
      type: String,
      default: '100%'
    },
    isshow: {
      type: Boolean,
      default: true
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    showText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      areaOptions: [],
      areaData: []
    }
  },
  mounted() {
    this.getAreaList()
  },
  methods: {
    getArea(data) {
      this.areaData = data
      this.getLogUtils().logWithTag('getCloudCode', data)
    },
    areaChange() {
      this.$emit('getAreaData', this.areaData)
    },
    getAreaList() {
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        if (this.isshow) {
          this.areaOptions = res
        } else {
          let arr = res
          arr.forEach(item => {
            item.children.forEach(item2 => {
              delete item2.children
            })
          })
          this.getLogUtils().logWithTag('getAreaList', arr)
          this.areaOptions = arr
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }

  }
}
</script>
<style scoped lang="less">
</style>